/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BankAccountViewModel,
  DeleteBankAccountOrchestration,
  ErrorResult,
  NotFoundErrorResult,
  PaymentDetailsViewModel,
  Result,
  ResultOfBankAccountViewModel,
  ResultOfListOfJurisdictionSchemeModel,
  ResultOfPaymentDetailsViewModel,
  ValidationErrorResult,
} from '../models';
import {
    BankAccountViewModelFromJSON,
    BankAccountViewModelToJSON,
    DeleteBankAccountOrchestrationFromJSON,
    DeleteBankAccountOrchestrationToJSON,
    ErrorResultFromJSON,
    ErrorResultToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    PaymentDetailsViewModelFromJSON,
    PaymentDetailsViewModelToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfBankAccountViewModelFromJSON,
    ResultOfBankAccountViewModelToJSON,
    ResultOfListOfJurisdictionSchemeModelFromJSON,
    ResultOfListOfJurisdictionSchemeModelToJSON,
    ResultOfPaymentDetailsViewModelFromJSON,
    ResultOfPaymentDetailsViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface PaymentDetailsDeleteBankAccountRequest {
    deleteBankAccount: DeleteBankAccountOrchestration;
}

export interface PaymentDetailsGetRequest {
    proposalId: number;
}

export interface PaymentDetailsGetJurisdictionSchemesRequest {
    productCode?: PaymentDetailsGetJurisdictionSchemesProductCodeEnum;
    transferMethod?: PaymentDetailsGetJurisdictionSchemesTransferMethodEnum;
}

export interface PaymentDetailsPostRequest {
    proposalId: number;
    paymentDetails: PaymentDetailsViewModel;
}

export interface PaymentDetailsUpsertBankAccountRequest {
    bankAccount: BankAccountViewModel;
}

/**
 * 
 */
export class PaymentDetailsApi extends runtime.BaseAPI {

    /**
     * Delete a BankAccount
     */
    async paymentDetailsDeleteBankAccountRaw(requestParameters: PaymentDetailsDeleteBankAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.deleteBankAccount === null || requestParameters.deleteBankAccount === undefined) {
            throw new runtime.RequiredError('deleteBankAccount','Required parameter requestParameters.deleteBankAccount was null or undefined when calling paymentDetailsDeleteBankAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/payment-details`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteBankAccountOrchestrationToJSON(requestParameters.deleteBankAccount),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Delete a BankAccount
     */
    async paymentDetailsDeleteBankAccount(requestParameters: PaymentDetailsDeleteBankAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.paymentDetailsDeleteBankAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the payment details for a proposal.
     */
    async paymentDetailsGetRaw(requestParameters: PaymentDetailsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfPaymentDetailsViewModel>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling paymentDetailsGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/payment-details/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfPaymentDetailsViewModelFromJSON(jsonValue));
    }

    /**
     * Gets the payment details for a proposal.
     */
    async paymentDetailsGet(requestParameters: PaymentDetailsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfPaymentDetailsViewModel> {
        const response = await this.paymentDetailsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the Jurisdiction Schemes.
     */
    async paymentDetailsGetJurisdictionSchemesRaw(requestParameters: PaymentDetailsGetJurisdictionSchemesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfListOfJurisdictionSchemeModel>> {
        const queryParameters: any = {};

        if (requestParameters.productCode !== undefined) {
            queryParameters['productCode'] = requestParameters.productCode;
        }

        if (requestParameters.transferMethod !== undefined) {
            queryParameters['transferMethod'] = requestParameters.transferMethod;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/payment-details/jurisdiction-schemes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfListOfJurisdictionSchemeModelFromJSON(jsonValue));
    }

    /**
     * Gets the Jurisdiction Schemes.
     */
    async paymentDetailsGetJurisdictionSchemes(requestParameters: PaymentDetailsGetJurisdictionSchemesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfListOfJurisdictionSchemeModel> {
        const response = await this.paymentDetailsGetJurisdictionSchemesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Posts the specified payment details view model.
     */
    async paymentDetailsPostRaw(requestParameters: PaymentDetailsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling paymentDetailsPost.');
        }

        if (requestParameters.paymentDetails === null || requestParameters.paymentDetails === undefined) {
            throw new runtime.RequiredError('paymentDetails','Required parameter requestParameters.paymentDetails was null or undefined when calling paymentDetailsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/payment-details/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PaymentDetailsViewModelToJSON(requestParameters.paymentDetails),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Posts the specified payment details view model.
     */
    async paymentDetailsPost(requestParameters: PaymentDetailsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.paymentDetailsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upserts the bank account.
     */
    async paymentDetailsUpsertBankAccountRaw(requestParameters: PaymentDetailsUpsertBankAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfBankAccountViewModel>> {
        if (requestParameters.bankAccount === null || requestParameters.bankAccount === undefined) {
            throw new runtime.RequiredError('bankAccount','Required parameter requestParameters.bankAccount was null or undefined when calling paymentDetailsUpsertBankAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/payment-details/bank-account`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BankAccountViewModelToJSON(requestParameters.bankAccount),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfBankAccountViewModelFromJSON(jsonValue));
    }

    /**
     * Upserts the bank account.
     */
    async paymentDetailsUpsertBankAccount(requestParameters: PaymentDetailsUpsertBankAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfBankAccountViewModel> {
        const response = await this.paymentDetailsUpsertBankAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const PaymentDetailsGetJurisdictionSchemesProductCodeEnum = {
    Gafdsp: 'GAFDSP',
    Gafend: 'GAFEND',
    Gaflai: 'GAFLAI',
    Gaflam: 'GAFLAM',
    Gaflan: 'GAFLAN',
    Gafppe: 'GAFPPE',
    Gafppr: 'GAFPPR',
    Gafraf: 'GAFRAF',
    Gafsnk: 'GAFSNK',
    Gaftfs: 'GAFTFS'
} as const;
export type PaymentDetailsGetJurisdictionSchemesProductCodeEnum = typeof PaymentDetailsGetJurisdictionSchemesProductCodeEnum[keyof typeof PaymentDetailsGetJurisdictionSchemesProductCodeEnum];
/**
 * @export
 */
export const PaymentDetailsGetJurisdictionSchemesTransferMethodEnum = {
    Cash: 'CASH',
    Units: 'UNITS'
} as const;
export type PaymentDetailsGetJurisdictionSchemesTransferMethodEnum = typeof PaymentDetailsGetJurisdictionSchemesTransferMethodEnum[keyof typeof PaymentDetailsGetJurisdictionSchemesTransferMethodEnum];
